export default __webpack_public_path__ + "static/media/Ballroll_00354.15fbf991.png";